<template>
    <div class="main">
        <div
            :class="{ backdrop: linksOpen }"
            @click="hideLinks"
        />
        <div
            :class="[ 'navigation-list',
                      displaySmallOrExtraSmall ? 'navigation-list-burger' : '',
                      displaySmallOrExtraSmall && linksOpen ? 'navigation-list-burger-open' : '',
                      !displaySmallOrExtraSmall && isSelected ? 'selected-nav-list' : '']"
        >
            <button
                ref="mainLink"
                :aria-expanded="subLinksOpen.toString()"
                :aria-haspopup="true"
                :aria-current="isSelected ? 'true' : null"
                :aria-controls="header + '-menu'"
                :class="['ul-header', linksOpen ? 'ul-header-hover' : '',
                         displaySmallOrExtraSmall ? 'ul-header-burger' : '',
                         displaySmallOrExtraSmall && linksOpen ? 'ul-header-burger-open' : '',
                         displaySmallOrExtraSmall && isSelected ? 'selected-nav-list-burger' : '' ]"
                @click="toggleLinks"
                @keydown.esc="hideLinks"
                @keydown.tab="(event) => { if (event.shiftKey) linksOpen = false }"
            >
                {{ header }}
                <div
                    v-if="!displaySmallOrExtraSmall"
                    class="arrows"
                >
                    <img
                        v-if="linksOpen"
                        class="link-icon"
                        :src="arrowUpUrl"
                        :alt="arrowUpAlt"
                        aria-hidden="true"
                    >
                    <img
                        v-else
                        class="link-icon"
                        :src="arrowDownUrl"
                        :alt="arrowDownAlt"
                        aria-hidden="true"
                    >
                </div>
                <div
                    v-else
                    class="plus-minus"
                >
                    <img
                        v-if="linksOpen"
                        :class="['link-icon', linksOpen ? 'link-icon-open': '' ]"
                        :src="minusUrl"
                        :alt="minusAlt"
                        aria-hidden="true"
                    >
                    <img
                        v-else
                        :class="['link-icon', linksOpen ? 'link-icon-open': '' ]"
                        :src="plusUrl"
                        :alt="plusAlt"
                        aria-hidden="true"
                    >
                </div>
            </button>
            <div
                v-show="linksOpen"
                :class="[ 'link-list',
                          displaySmallOrExtraSmall ? 'link-list-burger' : '']"
                aria-hidden="false"
            >
                <ul :id="header +'-menu'">
                    <custom-router-link
                        v-for="(link, index) in links"
                        :key="index"
                        :index="index"
                        :to="link.to"
                        :text-term="link.textTerm"
                        @focus="handleFocus"
                        @close-hamburger-menu="closeHamburgerMenu"
                        @hide-links="hideLinks"
                    />
                </ul>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Vue, Prop } from "vue-facing-decorator"
    import CustomRouterLink from "@/components/CustomRouterLink.vue"

    @Component({
        components: {
            "custom-router-link": CustomRouterLink
        }
    })
    export default class NavigationList extends Vue {
        @Prop({ type: String }) header: string | undefined
        @Prop({ type: Array, default: [] }) links!: Array<any>

        linksOpen: boolean = false

        get arrowDownUrl(): string {
            return this.$store.getters.contentServiceUrl + "/Content/icons/svg-blue/vakanen-alas-valkoinen.svg" + "?" + this.$store.getters.contentServiceTimeStamp
        }

        get arrowUpUrl(): string {
            return this.$store.getters.contentServiceUrl + "/Content/icons/svg-blue/vakanen-ylos.svg" + "?" + this.$store.getters.contentServiceTimeStamp
        }

        get arrowUpAlt(): string | undefined {
            return this.$t("App.NavigationList.ArrowUpAlt")
        }

        get arrowDownAlt(): string | undefined {
            return this.$t("App.NavigationList.ArrowDownAlt")
        }

        get minusUrl(): string {
            return this.$store.getters.contentServiceUrl + "/Content/icons/svg-blue/miinus.svg" + "?" + this.$store.getters.contentServiceTimeStamp
        }

        get plusUrl(): string {
            return this.$store.getters.contentServiceUrl + "/Content/icons/svg-blue/plus.svg" + "?" + this.$store.getters.contentServiceTimeStamp
        }

        get minusAlt(): string | undefined {
            return this.$t("App.NavigationList.MinusAlt")
        }

        get plusAlt(): string | undefined {
            return this.$t("App.NavigationList.PlusAlt")
        }

        get isSelected(): boolean {
            return this.links.some(link => this.$route.fullPath.includes(link.to))
        }

        // ruutukoko
        get displayType(): string {
            return this.$store.getters.displayType
        }

        get displayLarge(): string {
            return this.$store.state.displayLarge
        }

        get displayExtraLarge(): string {
            return this.$store.state.displayExtraLarge
        }

        get displayMedium(): string {
            return this.$store.state.displayMedium
        }

        get displaySmall(): string {
            return this.$store.state.displaySmall
        }

        get displayExtraSmall(): string {
            return this.$store.state.displayExtraSmall
        }

        get displaySmallOrExtraSmall(): boolean {
            return this.displayType === this.displaySmall || this.displayType === this.displayExtraSmall
        }

        get subLinksOpen(): boolean {
            return this.linksOpen
        }

        handleFocus(index) {
            // Tarkistetaan, onko kohdistettu elementti listan viimeinen
            // Jos kyll�, suljetaan lista
            if (index === this.links.length - 1) {
                this.linksOpen = false
            }
        }

        hideLinks(): void {
            if (!this.linksOpen) {
                this.closeHamburgerMenu()
            }
            else {
                (this.$refs.mainLink as HTMLButtonElement).focus()
                this.linksOpen = false
            }
        }

        toggleLinks(): void {
            this.linksOpen = !this.linksOpen
        }

        closeHamburgerMenu(): void {
            this.$emit("closeHamburgerMenu")
        }
    }
</script>

<style scoped>

    .navigation-list {
        height: 100%;
    }

    .main {
        height: 100%;
    }

    .navigation-list-burger {
        width: 100%;
        margin-top: 5px;
    }

    .navigation-list-burger-open {
        background-color: white;
        position: relative;
    }

    .ul-header {
        height: 100%;
        padding: 0px 20px;
        display: flex;
        align-items: center;
        color: #FFFFFF;
        font: normal normal 600 16px/19px Montserrat;
        text-transform: uppercase;
        letter-spacing: 0.48px;
        cursor: pointer;
        background: none;
        border-bottom: 5px solid transparent;
        border-top: 5px solid transparent;
        border-left: unset;
        border-right: unset;
    }

        .navigation-list.selected-nav-list {
            border-bottom: 5px solid #FFFFFF;
        }

        .ul-header.selected-nav-list-burger {
            border-left: 5px solid #FFFFFF;
        }

        .ul-header:hover {
            text-decoration: underline;
        }

        .ul-header a:hover {
            background: none;
        }

        .ul-header:focus {
            outline: 3px solid white;
            outline-offset: -4px;
        }
    .ul-header-hover:focus {
        outline: 3px solid var(--Traficom-main-color);
        outline-offset: -4px;
    }

    .ul-header-burger {
        margin: 5px 0px;
        padding: 15px 20px 15px 15px;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-bottom: unset;
        border-top: unset;
    }

    .ul-header-burger-open {
        color: var(--Traficom-main-color);
    }

    .ul-header.ul-header-hover {
        color: var(--Traficom-main-color);
        background-color: #F2F4F8;
    }

    .link-icon {
        pointer-events: none;
        width: 14px;
        margin-left: 10px;
    }

    .link-list {
        background-color: #FFFFFF;
        position: absolute;
        z-index: 10020;
        height: auto;
        width: fit-content;
        box-shadow: rgb(0 0 0 / 5%) 0em 0.45em 0.2em 0em;
    }

        .link-list ul {
            list-style-type: none;
            padding: 0;
        }

        .link-list ul li a {
            padding: 15px 20px;
        }

    .link-list-burger {
        width: 100%;
        position: unset;
        box-shadow: unset;
    }

        .link-list-burger ul {
            margin: 0;
        }

        .link-list-burger ul li a {
            padding: 15px 20px 15px 15px;
        }

    .plus-minus {
        display: flex;
        flex-grow: 1;
        justify-content: flex-end;
        pointer-events: none;
    }

    .plus-minus .link-icon {
        filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(245deg) brightness(113%) contrast(101%);
        width: 22px;
    }

    .plus-minus .link-icon-open {
        filter: none;
    }
    .backdrop {
    display: flex;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    }
</style>
